<template>
	<div class="land-area-field">
		<EditableField
			name="subjectLandAreaOverrideSqft"
			:title="t('transaction.card.fields.totalLandArea')"
			:hide-title="hideTitle"
			type="number"
			:value="displayArea"
			:symbol="areaUnitSymbol"
			:disabled="disabled"
			:debounce-ms="0"
			@input="update($event.value)"
		/>
		<Button v-if="value != null" variant="ghost" size="xs" :disabled="disabled" @click="value = null">
			{{ t("comparableAnalysis.useLotArea") }}
		</Button>
	</div>
</template>
<script setup lang="ts">
import { computed } from "vue"
import { useI18n } from "vue-i18n"
import EditableField from "@/components/transactions/EditableField.vue"
import Button from "@/components/ui/Button.vue"
import { useUnitSystem } from "@/composables/useUnitSystem"
import { AreaUnit, convertArea } from "@/utils/unitSystem"

const value = defineModel<number | null>()
const props = defineProps<{ parcelAreaSqft?: number | null; disabled?: boolean; hideTitle?: boolean }>()
const { t } = useI18n()
const { areaUnit, areaUnitSymbol } = useUnitSystem()
const displayArea = computed(() => {
	const area = value.value ?? props.parcelAreaSqft
	return area == null ? null : convertArea(area, AreaUnit.SquareFeet, areaUnit.value)
})
function update(input: unknown) {
	if (props.disabled) return
	value.value = typeof input === "number" ? convertArea(input, areaUnit.value, AreaUnit.SquareFeet) : null
}
</script>
<style scoped>
.land-area-field {
	:deep(.editable-field) {
		min-width: 0;
	}
}
</style>
